import { createStore, Store } from 'vuex';
import { IRootState } from '@/types/app';
import { getModule } from 'vuex-module-decorators';
import app from './modules/app';
import auth from './modules/auth';
import tagsView from './modules/tagsView';
import getters from './getters';

const store: Store<IRootState> = createStore({
  modules: {
    app,
    auth,
    tagsView,
  },
  getters,
});

const appModule = getModule(app, store);
const authModule = getModule(auth, store);
const tagsViewModule = getModule(tagsView, store);

export { appModule as app, authModule as auth, tagsViewModule as tagsView };

export default store;
